import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { motion } from 'framer-motion';
import 'swiper/css';
import 'swiper/css/autoplay';
import './BrandArea.css';

const BrandArea = () => {
  const brands = [
    {
      thumbSrc: 'assets/brands/scratch.png',
      altText: 'Scratch',
      color: '#F7A52C',
      textColor: '#FFD166'
    },
    {
      thumbSrc: 'assets/brands/thunkable.png',
      altText: 'Thunkable',
      color: '#3F8DFD',
      textColor: '#90CAF9'
    },
    {
      thumbSrc: 'assets/brands/tinkercad.png',
      altText: 'Tinkercad',
      color: '#2BC4D6',
      textColor: '#80DEEA'
    },
    {
      thumbSrc: 'assets/brands/cospaces.png',
      altText: 'CoSpaces',
      color: '#6C5CE7',
      textColor: '#B39DDB'
    },
    {
      thumbSrc: 'assets/brands/python.png',
      altText: 'Python',
      color: '#3776AB',
      textColor: '#90CAF9'
    },
    {
      thumbSrc: 'assets/brands/web.png',
      altText: 'Web Technologies',
      color: '#E44D26',
      textColor: '#FFAB91'
    }
  ];

  return (
    <section className="brands-section">
      <div className="container">
        <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Technologies We Teach</h2>
          <p className="section-subtitle">
            Partnered with leading platforms to deliver cutting-edge education
          </p>
        </motion.div>

        <div className="brands-slider-wrapper">
          <Swiper
            className="brands-slider"
            speed={1500}
            loop={true}
            slidesPerView={5}
            spaceBetween={40}
            autoplay={{ 
              delay: 2000, 
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            modules={[Autoplay]}
            breakpoints={{
              1400: { slidesPerView: 5 },
              1200: { slidesPerView: 4 },
              992: { slidesPerView: 3 },
              768: { slidesPerView: 2 },
              576: { slidesPerView: 2 },
              0: { slidesPerView: 2 }
            }}
          >
            {brands.map((brand, index) => (
              <SwiperSlide key={index}>
                <motion.div 
                  className="brand-card"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <div 
                    className="brand-logo-container"
                    style={{ 
                      backgroundColor: `${brand.color}20`,
                      border: `1px solid ${brand.color}50`
                    }}
                  >
                    <img 
                      src={brand.thumbSrc} 
                      alt={brand.altText} 
                      className="brand-logo"
                      style={{ filter: 'none', opacity: 1 }}
                    />
                  </div>
                  <span 
                    className="brand-name"
                    style={{ color: brand.textColor }}
                  >
                    {brand.altText}
                  </span>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default BrandArea;